import XHTTP from "services/api/xhttp";
import paths from "routes/paths";

class ParkStatisticsApi {
  static END_POINTS = {
    getGeneralStats: (type) =>
      paths?.api?.parkStatistics?.[
        `data${type === "areas" ? "ByAreas" : "ByRadius"}`
      ]?.general,
    getControlsStats: (type) =>
      paths?.api?.parkStatistics?.[
        `data${type === "areas" ? "ByAreas" : "ByRadius"}`
      ]?.controls,
    getDailyAttendanceStats: (type) =>
      paths?.api?.parkStatistics?.[
        `data${type === "areas" ? "ByAreas" : "ByRadius"}`
      ]?.dailyAttendance,
    getDetailsStats: (type) =>
      paths?.api?.parkStatistics?.dataByAreas.occupancy,
    getAllStats: paths?.api?.parkStatistics?.all,
  };

  static getGeneralStats(type, filters) {
    return XHTTP(ParkStatisticsApi.END_POINTS.getGeneralStats(type), {
      method: "post",
      body: JSON.stringify(filters),
    });
  }

  static getDetailsStats(type, filters) {
    return XHTTP(ParkStatisticsApi.END_POINTS.getDetailsStats(type), {
      method: "post",
      body: JSON.stringify(filters),
    });
  }

  static getControlsStats(type, filters) {
    return XHTTP(ParkStatisticsApi.END_POINTS.getControlsStats(type), {
      method: "post",
      body: JSON.stringify(filters),
    });
  }

  static getDailyAttendanceStats(type, filters) {
    return XHTTP(ParkStatisticsApi.END_POINTS.getDailyAttendanceStats(type), {
      method: "post",
      body: JSON.stringify(filters),
    });
  }

  static lockSpace(uid, contractID, isLocked) {
    return XHTTP(paths.api.parkStatistics.lock, {
      method: "put",
      body: JSON.stringify({
        uid,
        contract_id: contractID,
        is_locked: isLocked,
      }),
    });
  }

  static getAllStats(filters) {
    return XHTTP(ParkStatisticsApi.END_POINTS.getAllStats, {
      method: "post",
      body: JSON.stringify(filters),
    });
  }
}

export default ParkStatisticsApi;
